import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {MultipartyDashboardController} from '../../../../MultipartyDashboardController';
import {ITranslate} from '../../../../../../services/LocalizationService';
import {InteractionSummaryTitle} from './InteractionSummaryTitle';
import {InteractionSummaryPreviewCard} from './InteractionSummaryPreviewCard';

type InteractionSummaryCollapsibleProps = {
    controller: MultipartyDashboardController;
    translate: ITranslate;
    dateFormat?: string;
};

@observer
export class InteractionSummaryCollapsible extends TechseeBaseComponent<InteractionSummaryCollapsibleProps> {
    renderInternal(): JSX.Element {
        const {controller, translate, dateFormat} = this.props;

        return (
            <div
                className={`collapsible-panel gallery-collapsible interaction-summary-collapsible ${
                    controller.interactionSummaryIsOpen ? 'interaction-summary-collapsible--open' : ''
                }`}>
                <header className={'default-style cursor-style-pointer'} onClick={controller.toggleInteractionSummary}>
                    <InteractionSummaryTitle translate={translate} />
                </header>
                <div>
                    {controller.interactionSummaryIsOpen && (
                        <div className='interaction-summary-condensed'>
                            {controller.interactionSummaryPreviews.map((preview: any, idx: number) => (
                                <InteractionSummaryPreviewCard
                                    key={`preview-${preview.sessionId}-${idx}`}
                                    preview={preview}
                                    translate={translate}
                                    dateFormat={dateFormat}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
